import React from 'react';
import { Inline } from '@atlaskit/primitives';
import { TableLoader } from './common/table-loader';
import { TabsLoader } from './common/tabs-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { BoxLoader } from './common/box-loader';
import { CollapsibleSummaryLoader } from './common/collapsible-summary-loader';

export const CreditDetailsPageLoader = () => {
  return (
    <div className="pl-8">
      <PageHeaderLoader />
      <Inline grow="fill" space="space.200">
        {Array.from({ length: 3 }).map((_, index) => (
          <Inline grow="fill" key={index}>
            <BoxLoader columnsCount={1} contentWidth="50%" width="100%" />
          </Inline>
        ))}
      </Inline>
      <CollapsibleSummaryLoader rowsCount={1} />
      <br />
      <TabsLoader />
      <TableLoader hideActions columnsCount={7} />
      <br />
    </div>
  );
};
